<ng-template #content>
  <div style="width: 100%; height: 100%" [style.opacity]="disabled? 0.4 : null">
    <div style="height: 100%"
         fxLayout="column"
         fxLayoutAlign="space-between start"
         [style.visibility]="loading ? 'hidden' : 'visible'">
      <app-icon [width]="iconSize ? iconSize : 30"
                [height]="iconSize ? iconSize : 30"
                class="accent-color" [name]="icon"></app-icon>
      <div>
        <h1 class="primary-color" style="max-width: 160px">{{ title }}</h1>
      </div>
    </div>

    <div [ngClass]="['loader']" *ngIf="loading">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </div>
</ng-template>

<button
  class="payka-button"
  [style.height]="height"
  (mouseenter)="hovered = true"
  (mouseleave)="hovered = false"
  [ngStyle]="{'background-color': currentBgColor, 'height': height, 'width': '100%', 'padding': '30px',
  filter: shoudAddFilter ?  'saturate(120%)': null}"
  [disabled]="disabled"
  (click)="onClick()">
  <ng-container [ngTemplateOutlet]="content"></ng-container>

  <div class="custom-content-wrapper">
    <ng-content></ng-content>
  </div>
</button>
